








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import formateData from '../../common/utils/formateData';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { jumpToHQ } from '../../common/client-agreement/jumpAgreement';
import "swiper/dist/css/swiper.css";
import { isJiaoYi } from '../../pages/indexPage/common/sourceConfig';

const win: any = window;
const { hxmClickStat } = win;

@Component({
  components: {
    swiper,
    swiperSlide,
  }
})
export default class StockList extends Vue {
  public $refs: any;

  @Prop() private readonly titleData!: any;
  @Prop() private readonly listData!: any;
  @Prop() private readonly options!: any;
  @Prop() private readonly jumpConfig!: any;
  @Prop() private readonly maidian!: any;
  @Prop() private readonly type!: any;

  private showIcon: boolean = true;

  private swiperOptions = {
    slidesPerView: 'auto', // 一屏显示多少slide
    initialSlide: 0,
    resistanceRatio: 0,
    freeMode: true,
    mousewheel: true,
    on: {
      transitionEnd: this.showRightIcon,
    },
  }
  
  @Watch('type', {immediate: false, deep: true})
  getNewData(newVal: any) {
    if (this.$refs.swiperContext && this.$refs.swiperContext.swiper) {
      this.$refs.swiperContext.swiper.slideTo(0);
    }
    if (this.$refs.swiperTitle && this.$refs.swiperTitle.swiper) {
      this.$refs.swiperTitle.swiper.slideTo(0);
    }
  };

  private created() {
    if (this.options) {
      this.swiperOptions = {
        ...this.swiperOptions,
        ...this.options,
      }
    }
    // 设置表头和内容联动
    this.$nextTick(() => {
      this.$refs.swiperContext.swiper.controller.control = this.$refs.swiperTitle.swiper;
      this.$refs.swiperTitle.swiper.controller.control = this.$refs.swiperContext.swiper;
    })
  }

  private showRightIcon() {
    if (this.$refs.swiperContext.swiper.isEnd) {
      this.showIcon = false;
    } else {
      this.showIcon = true;
    }
    hxmClickStat(this.maidian + '.fy');
  }

  private getFormateValue(value: number | string, unit: string) {
    return formateData(value, unit);
  }

  private getColor(value: any, unit: string) {
    if (unit !== '%' && unit !== 'winning' && unit !== 'premium') {
      return '';
    }
    if ((value > 0 || Number(value) > 0)) {
      return 'basic-red';
    }
    if ((value < 0 || Number(value) < 0)) {
      return 'basic-green';
    }
    return ''
  }

  private handleSeeDetial(item: any, type: string, moduleType: string, index: number) {
    const rowMaidian = `${this.maidian}.${index + 1}`;
    hxmClickStat(rowMaidian);
  
    // 上市表现跳转分时页
    if (moduleType === 'ssbx') {
      jumpToHQ(item.code, item.marketId);
      return;
    }
    // 待上市跳转详情页
    if (moduleType === 'wait_listing') {
      const stocktype = type === 'bjs' ? 'bjs' : (item.exchange === 'BOND' ? 'agubond' : 'agustock');
      let jumpURL = `//data.10jqka.com.cn/datacenterph/ipo/detail.html?code=${item.code}&marketid=${item.marketId}&module=wait_listing&tab=${this.maidian}&stocktype=${stocktype}#/`
      if(isJiaoYi){
        jumpURL = `//data.10jqka.com.cn/datacenterph/ipo/detail.html?source=jiaoyi&code=${item.code}&marketid=${item.marketId}&module=wait_listing&tab=${this.maidian}&stocktype=${stocktype}#/`
      }
      win.F10Utils.jumpToLink({url: jumpURL}
      )
    }
  }
  // 获取当前股票的市场
  private getMarket(exchange: string) {
    const marketObj: any = {
      H: { name: '沪', color: 'red' },
      S: { name: '深', color: 'red' },
      GEM: { name: '创', color: 'orange' },
      STAR: { name: '科', color: 'blue' },
      BOND: { name: '债', color: 'red' },
      J: { name: '京', color: 'red' },
    };
    return marketObj[exchange] || { name: '', color: ''};
  }
  // 判断是否是更宽的列宽 UI要求上市日和每签最高获利更宽
  private isWider(item: any) {
    return item.title === '上市日' || item.title === '每签最高获利' || item.title === '每百股最高获利';
  }
}
